import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationAnalyticsComponent } from './application-analytics.component';
import {ToastModule} from "primeng/toast";
import {CalendarModule} from "primeng/calendar";
import {ReactiveFormsModule} from "@angular/forms";
import {DropdownModule} from "primeng/dropdown";
import {InputTextModule} from "primeng/inputtext";
import {RippleModule} from "primeng/ripple";
import {TabViewModule} from "primeng/tabview";
import {TableModule} from "primeng/table";
import {DialogModule} from "primeng/dialog";
import {ChartModule} from "primeng/chart";
import {PaginatorModule} from "primeng/paginator";



@NgModule({
  declarations: [ApplicationAnalyticsComponent],
    imports: [
        CommonModule,
        ToastModule,
        CalendarModule,
        ReactiveFormsModule,
        DropdownModule,
        InputTextModule,
        RippleModule,
        TabViewModule,
        TableModule,
        DialogModule,
        ChartModule,
        PaginatorModule
    ]
})
export class ApplicationAnalyticsModule { }
